import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button } from "antd";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../../../../store";
import HasPermissions from "../../../../../containers/HasPermissions";
import { DateTimeFormat, PercentFormat } from '../../../components/FormattersTS';
import FuelLevyCreateModal from '../FuelLevyCreateModal';
import FuelLevyDateModal from '../FuelLevyDateModal';
import { isUserMultiTenant } from "../../../../../swzutils/UserPermissionsUtil";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../../store/slice/auth";
import DateRangeDescription from "../../../components/DateRangeDescription";
import ActiveStatusTag from "../../../components/ActiveStatusTag";
const FuelLevyRateTable = () => {
    const tableRef = useRef(null);
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [effectiveDateFuelLevy, setEffectiveDateFuelLevy] = useState(undefined);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const showCreateModal = () => {
        setCreateModalVisible(true);
    };
    const hideCreateModal = () => {
        setCreateModalVisible(false);
    };
    const showDateModal = (fuelLevy) => {
        setEffectiveDateFuelLevy(fuelLevy);
    };
    const hideDateModal = () => {
        setEffectiveDateFuelLevy(undefined);
    };
    const columns = [{
            title: 'Profile',
            dataIndex: ['tenant', 'name'],
            sorter: false,
            width: '30%',
            condition: isUserMultiTenant(loggedInUser) && !selectedTenant?.id,
        }, {
            title: 'Effective Dates',
            dataIndex: 'effectiveFrom',
            width: '20%',
            filter: {
                type: 'dateRange',
                requestKey: 'effectiveOnOrAfterDate',
                requestKeyDateTo: 'effectiveOnOrBeforeDate'
            },
            render: (text, fuelLevy) => {
                if (fuelLevy.effectiveTo) {
                    return (_jsx(DateRangeDescription, { fromISOTimestamp: fuelLevy.effectiveFrom, toISOTimestamp: fuelLevy.effectiveTo }));
                }
                return (_jsx(DateTimeFormat, { value: text }));
            }
        }, {
            title: 'Active',
            key: 'effectiveAsOfNow',
            dataIndex: "effectiveAsOfNow",
            width: '5%',
            filter: {
                type: 'enum',
                requestKey: 'effectiveAsOfNow',
                enums: [{
                        text: 'Active',
                        value: true,
                    }, {
                        text: 'Inactive',
                        value: false,
                    }],
                filterMultiple: false,
            },
            render: (text, record) => (_jsx(ActiveStatusTag, { active: record.effectiveAsOfNow }))
        }, {
            title: 'Percentage',
            dataIndex: 'levyPercent',
            width: '5%',
            render: (text /*, fuelLevy*/) => (_jsx(PercentFormat, { value: text }))
        }, {
            title: 'Created At',
            dataIndex: 'createdAt',
            width: '20%',
            render: (text /*, fuelLevy*/) => (_jsx(DateTimeFormat, { value: text }))
        }, {
            title: 'Action',
            width: '5%',
            render: (text, fuelLevy) => (_jsx(HasPermissions, { permissions: ['admin:fuelLevy:update'], children: _jsx(Button, { onClick: () => showDateModal(fuelLevy), children: "End Date" }) }))
        }];
    return (_jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Fuel Levies" }), _jsxs("div", { className: "table-operations clearfix", children: [_jsx(HasPermissions, { permissions: ['admin:fuelLevy:create'], children: _jsx(Button, { onClick: showCreateModal, icon: _jsx(PlusOutlined, {}), children: "Add a new Fuel Levy" }) }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'fuelLeviesTable', ref: tableRef, dataUri: "/admin/v1/fuel-levies", columns: columns, refreshOnSelectedTenantChanged: true, initialFilters: {
                    "effectiveAsOfNow": [true]
                } }), _jsx(FuelLevyCreateModal, { open: createModalVisible, onSuccess: ( /*fuelLevy: FuelLevyResponse*/) => {
                    refresh();
                    hideCreateModal();
                }, onCancel: hideCreateModal }), _jsx(FuelLevyDateModal, { open: !!effectiveDateFuelLevy, fuelLevy: effectiveDateFuelLevy, onSuccess: () => {
                    refresh();
                    hideDateModal();
                }, onCancel: hideDateModal })] }));
};
export default FuelLevyRateTable;
